export enum locales {
    EN = 'en',
    CN = 'cn',
  }